import { CommissionWithGroupsTable } from "components/Tables/CommissionGroupTable/CommissionsGroupTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getAffiliateHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/")({
    component: AffiliateCommissionGroupsPage,
    staticData: {
        permissions: [PermissionEnum.CommissionGroupPageView],
        showInSideMenu: false,
        label: "pages.affiliate.commission.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.affiliate.commission.title"),
        };
    },
});

/**
 * List of commission groups
 * @returns
 */
function AffiliateCommissionGroupsPage(): JSX.Element {
    return (
        <TenantPage headerNavigationItems={getAffiliateHeaderItems}>
            <CommissionWithGroupsTable />
        </TenantPage>
    );
}
